import React, { FunctionComponent } from 'react'
import { ActivityMonitorToolbarContainer } from './activityMonitorStyles'
import { ToggleButtonStrip, ToggleButton } from 'view/components/buttons'
import { Translation } from 'locale'
import { iconSet } from 'view/components/icons'

interface ActivityMonitorToolbarProps {
  sortByTimeLeft: boolean
  disabled?: boolean
  onToggleTimer: () => unknown
}

export const ActivityMonitorToolbar: FunctionComponent<ActivityMonitorToolbarProps> = props => {
  const { sortByTimeLeft, disabled, onToggleTimer } = props
  return (
    <ActivityMonitorToolbarContainer>
      <ToggleButtonStrip>
        <ToggleButton
          tooltip={Translation.SC_ORDER_BY_TIME_REMAINING}
          disabled={disabled}
          onToggle={onToggleTimer}
          on={sortByTimeLeft}
          dataTestId="ActivityMonitorToolbar-OrderByTimeRemainingToggleButton">
          {iconSet.timerIcon}
        </ToggleButton>
      </ToggleButtonStrip>
    </ActivityMonitorToolbarContainer>
  )
}
